/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from "pinia";
import Axios from "@auth/vue-share/utility/axios";

export const useSessionsStore = defineStore({
  id: "sessions",
  state: () => ({
    sessions: []
  }),
  getters: {
    getSessions: (state) => state.sessions
  },
  actions: {
    fetchSessions() {
      Axios.get("session/sessions", "/api/sessions").then((response) => {
        this.sessions = response.data.data;
      });
    }
  }
});
